export const INPUT_LIMITS = {
  "bing-indexnow-api": {
    minlength: 0,
    maxlength: 100,
  },
  "portal-width": {
    minlength: 0,
    maxlength: 100,
  },
  "portal-height": {
    minlength: 0,
    maxlength: 100,
  },
  "custom-classname": {
    minlength: 0,
    maxlength: 100,
  },
  "custom-id": {
    minlength: 0,
    maxlength: 100,
  },
  "entrance-animation-trigger": {
    minlength: 0,
    maxlength: 100,
  },
  "outbound-link": {
    minlength: 0,
    maxlength: 2048,
  },
  "link-relation": {
    minlength: 0,
    maxlength: 50,
  },
  "component-name": {
    minlength: 0,
    maxlength: 50,
  },
  "start-counter": {
    minlength: 0,
    maxlength: 10,
    min: -9999999999,
    max: 9999999999,
  },
  "end-counter": {
    minlength: 0,
    maxlength: 10,
    min: -9999999999,
    max: 9999999999,
  },
  "counter-prefix": {
    minlength: 0,
    maxlength: 100,
  },
  "counter-suffix": {
    minlength: 0,
    maxlength: 100,
  },
  "grigora-form-action": {
    minlength: 0,
    maxlength: 50,
  },
  "simple-contact-form-name": {
    minlength: 0,
    maxlength: 50,
  },
  "form-input-name": {
    minlength: 0,
    maxlength: 50,
  },
  "dropdown-title": {
    minlength: 0,
    maxlength: 1024,
  },
  "dropdown-name": {
    minlength: 0,
    maxlength: 1024,
  },
  "form-input-label": {
    minlength: 0,
    maxlength: 50,
  },
  "form-text-value": {
    minlength: 0,
    maxlength: 500,
    step: 1,
  },
  "form-placeholder": {
    minlength: 0,
    maxlength: 50,
  },
  "form-title": {
    minlength: 0,
    maxlength: 100,
  },
  "form-date-pattern": {
    minlength: 0,
    maxlength: 100,
  },
  "google-map-longitude": {
    // minlength: -90,
    // maxlength: 90,
    minlength: 0,
    maxlength: 20,
  },
  "google-map-latitude": {
    // minlength: -90,
    // maxlength: 90,
    minlength: 0,
    maxlength: 20,
  },
  "google-map-location": {
    minlength: 0,
    maxlength: 500,
  },
  "google-map-api-key": {
    minlength: 0,
    maxlength: 40,
  },
  "image-title": {
    minlength: 0,
    maxlength: 100,
  },
  "image-caption": {
    minlength: 0,
    maxlength: 100,
  },
  "image-alt-text": {
    minlength: 0,
    maxlength: 200,
  },
  "lottie-aria-label": {
    minlength: 0,
    maxlength: 100,
  },
  "lottie-animation-url": {
    minlength: 0,
    maxlength: 500,
  },
  "newsletter-submit-message": {
    minlength: 0,
    maxlength: 1000,
  },
  "newsletter-placeholder": {
    minlength: 0,
    maxlength: 50,
  },
  "newsletter-text": {
    minlength: 0,
    maxlength: 100,
  },
  "newsletter-submit-btn": {
    minlength: 0,
    maxlength: 100,
  },
  "portal-cookie-name": {
    minlength: 0,
    maxlength: 100,
  },
  "post-categories": {
    min: 1,
    max: 200,
    step: 1,
  },
  "post-categories-separator": {
    minlength: 0,
    maxlength: 50,
  },
  "post-categories-attached-prefix": {
    minlength: 0,
    maxlength: 100,
  },
  "post-categories-attached-suffix": {
    minlength: 0,
    maxlength: 100,
  },
  "post-categories-link": {
    minlength: 0,
    maxlength: 2048,
  },
  "post-date-custom-format": {
    minlength: 0,
    maxlength: 50,
  },
  "post-prefix": {
    minlength: 0,
    maxlength: 100,
  },
  "post-suffix": {
    minlength: 0,
    maxlength: 100,
  },
  "text-suffix": {
    minlength: 0,
    maxlength: 100,
  },
  "search-input": {
    minlength: 0,
    maxlength: 200,
  },
  search: {
    minlength: 0,
    maxlength: 150,
  },
  "search-placeholder": {
    minlength: 0,
    maxlength: 50,
  },
  "search-button": {
    minlength: 0,
    maxlength: 100,
  },
  "social-links": {
    minlength: 0,
    maxlength: 100,
  },
  "social-link-prefix": {
    minlength: 0,
    maxlength: 100,
  },
  "social-link-suffix": {
    minlength: 0,
    maxlength: 100,
  },
  "star-rating-suffix": {
    minlength: 0,
    maxlength: 100,
  },
  "star-rating-prefix": {
    minlength: 0,
    maxlength: 100,
  },
  "video-poster": {
    minlength: 0,
    maxlength: 300,
  },
  "video-title": {
    minlength: 0,
    maxlength: 300,
  },
  "page-name": {
    minlength: 0,
    maxlength: 100,
  },
  "page-permalink": {
    minlength: 0,
    maxlength: 2048,
  },
  "page-title": {
    minlength: 0,
    maxlength: 150,
  },
  "website-name": {
    minlength: 0,
    maxlength: 63,
  },
  "custom-color-name": {
    minlength: 0,
    maxlength: 50,
  },
  "website-url": {
    minlength: 0,
    maxlength: 73,
  },
  "post-url": {
    minlength: 0,
    maxlength: 200,
  },
  "text-input": {
    minlength: 0,
    maxlength: 2048,
  },
  "default-text-input": {
    minlength: 0,
    maxlength: 524288,
  },
  "unit-input": {
    minlength: 0,
    maxlength: 10,
  },
  "border-input": {
    minlength: 0,
    maxlength: 10,
  },
  "post-keyword": {
    minlength: 0,
    maxlength: 150,
  },
  "slider-input": {
    minlength: 0,
    maxlength: 1000,
  },
  "folder-name": {
    minlength: 0,
    maxlength: 100,
  },
  "verification-code": {
    minlength: 0,
    maxlength: 10,
  },
  "filter-post-date-input": {
    minlength: 0,
    maxlength: 20,
  },
  "internal-links": {
    minlength: 0,
    maxlength: 150,
  },
  "external-links": {
    minlength: 0,
    maxlength: 150,
  },
  firstname: {
    minlength: 0,
    maxlength: 200,
  },
  lastname: {
    minlength: 0,
    maxlength: 200,
  },
  name: {
    minlength: 0,
    maxlength: 200,
  },
  slug: {
    minlength: 0,
    maxlength: 300,
  },
  mobile: {
    minlength: 0,
    maxlength: 15,
  },
  email: {
    minlength: 0,
    maxlength: 320,
  },
  password: {
    minlength: 0,
    maxlength: 128,
  },
  customdomain: {
    minlength: 0,
    maxlength: 255,
  },
  recaptcha: {
    minlength: 0,
    maxlength: 255,
  },
  "google-analytics-id": {
    minlength: 0,
    maxlength: 256,
  },
  "google-search-console": {
    minlength: 0,
    maxlength: 256,
  },
  "google-recaptcha": {
    minlength: 0,
    maxlength: 256,
  },
  "support-subject": {
    minlength: 0,
    maxlength: 250,
  },
  "support-message": {
    minlength: 0,
    maxlength: 5000,
  },
  "todo-task": {
    minlength: 0,
    maxlength: 150,
  },
  "custom-code": {
    minlength: 0,
    maxlength: 5000,
  },
  "form-textarea": {
    minlength: 0,
    maxlength: 5000,
    cols: {
      minCols: 3,
      maxCols: 100,
    },
    rows: {
      minRows: 6,
      maxRows: 100,
    },
  },
  "textarea-input": {
    minlength: 0,
    maxlength: 524288,
  },

  "seo-meta-title": {
    minlength: 0,
    maxlength: 200,
  },
  "seo-meta-description": {
    minlength: 0,
    maxlength: 600,
  },
  "seo-keyword": {
    minlength: 0,
    maxlength: 150,
  },
  "category-description": {
    minlength: 0,
    maxlength: 150,
  },
  "category-url": {
    minlength: 0,
    maxlength: 200,
  },
  "category-name": {
    minlength: 0,
    maxlength: 100,
  },
  "category-slug": {
    minlength: 0,
    maxlength: 150,
  },
  bio: {
    minlength: 0,
    maxlength: 300,
  },
  recaptcha: {
    minlength: 0,
    maxlength: 255,
  },
  "assignment-title": {
    minlength: 0,
    maxlength: 150,
  },
  "table-rows": {
    minlength: 1,
    maxlength: 100,
    step: 1,
  },
  "table-cols": {
    minlength: 1,
    maxlength: 15,
    step: 1,
  },
  "boxshadow-input": {
    minlength: 0,
    maxlength: 4,
    step: 1,
    spread: {
      minlength: 0,
      maxlength: 4,
    },
    blur: {
      minlength: 0,
      maxlength: 4,
    },
  },
  // number input
  "slider-delay": {
    max: 100000,
    min: 0,
  },
  "slider-limit": {
    max: 12,
    min: 1,
  },
  "slider-shadow-scale": {
    max: 1,
    min: 0,
    step: 0.01,
  },
  "slider-shadow-offset": {
    max: 1000,
    min: 0,
    step: 1,
  },
  "slider-coverflow-rotate": {
    min: 0,
    max: 1000,
    step: 1,
  },
  "slider-speed": {
    max: 100000,
    min: 0,
    step: 2,
  },
  "slider-bullet-opacity": {
    max: 1,
    min: 0,
    step: 0.1,
  },
  "margin-input": {
    minlength: 0,
    maxlength: 10,
    min: -100000000000,
    max: 100000000000,
  },
  "number-input": {
    minlength: 0,
    maxlength: 10,
  },
  "padding-input": {
    minlength: 0,
    maxlength: 10,
    min: 0,
    max: 100000000000,
  },
  "range-input": {
    minlength: 0,
    maxlength: 10,
  },

  "css-transform-animations-initial-scale": {
    min: 0.01,
    max: 10,
    step: 0.01,
  },

  "css-transform-animations-initial-opacity": {
    min: 0,
    max: 1,
    step: 0.01,
  },
  "css-transform-animations-initial-perspective": {
    min: 100,
    max: 4000,
    step: 100,
  },
  "css-transform-animations-hover-scale": {
    min: 0,
    max: 10,
    step: 0.01,
  },
  "css-transform-animations-hover-opacity": {
    min: 0,
    max: 1,
    step: 0.01,
  },
  "css-transform-animations-infinite-scale": {
    min: 0.01,
    max: 10,
    step: 0.01,
  },
  "css-transform-animations-infinite-opacity": {
    min: 0,
    max: 1,
    step: 0.01,
  },
  "entrance-animations-rotate-xyz": {
    min: -360,
    max: 360,
    step: 1,
  },
  "entrance-animations-skew-xy": {
    min: -360,
    max: 360,
    step: 1,
  },
  "entrance-animations-scale-xy": {
    min: 0,
    max: 10,
    step: 0.01,
  },
  "entrance-animations-opacity": {
    min: 0,
    max: 1,
    step: 0.01,
  },
  "entrance-animations-duration": {
    min: 0,
    max: 10000,
    step: 50,
  },
  "entrance-animations-perspective": {
    min: 0,
    max: 10000,
    step: 100,
  },
  "entrance-animations-delay": {
    min: 0,
    max: 10000,
    step: 50,
  },
  "position-support-zindex": {
    min: 0,
    max: 10000000,
    step: 1,
  },

  "sticky-support-offset": {
    min: 0,
    max: 10000,
    step: 1,
  },

  "number-of-categories": {
    min: 1,
    max: 100,
    step: 1,
  },
  "category-offset": {
    min: 0,
    max: 100,
    step: 1,
  },
  "cms-number-of-posts": {
    min: 1,
    max: 500,
    step: 1,
  },
  "cms-query-offset": {
    min: 0,
    max: 500,
    step: 1,
  },
  "form-date": {
    min: 0,
    max: 100,
    step: 1,
  },
  "form-range": {
    min: 0,
    max: 100,
    step: 1,
  },
  "form-toggle-positions": {
    min: -100,
    max: 2000,
  },
  "navigation-top-offset": {
    min: 0,
    max: 200,
  },
  "portal-after-time": {
    min: 1,
    max: 10000,
    step: 1,
  },
  "portal-delay": {
    min: 0,
    max: 1000000,
    step: 50,
  },

  "post-time-to-read-speed": {
    min: 50,
    max: 1000,
    step: 1,
  },
  "scroll-to-top-zindex": {
    min: 0,
    max: 100000,
    step: 1,
  },

  "toc-scroll-offset": {
    min: -1000,
    max: 1000,
    step: 1,
  },
  "angle-input": {
    min: 0,
    max: 360,
    step: 1,
  },
  "range-number-input": {
    min: 0,
    max: 100,
    step: 1,
  },
  // range input

  "code-font-size": {
    min: 0,
    max: 500,
    step: 1,
  },
  "cms-width-height": {
    min: 5,
    max: 100,
  },
  "cms-video-width-height": {
    min: 10,
    max: 1000,
  },

  "cms-gap": {
    min: 0,
    max: 100,
  },

  "container-opacity": {
    min: 0,
    max: 1,
    step: 0.02,
  },
  "container-opacity": {
    min: 0,
    max: 1,
    step: 0.02,
  },
  "count-up-time": {
    min: 0,
    max: 60,
    step: 0.5,
  },
  "form-option-radio-size": {
    min: 0,
    max: 100,
    step: 1,
  },
  "cms-google-map-width-height": {
    min: 5,
    max: 100,
    step: 1,
  },
  "cms-google-map-zoom": {
    min: 1,
    max: 20,
    step: 1,
  },
  "icon-size": {
    min: 1,
    max: 100,
    step: 1,
  },
  "cms-font-size": {
    min: 5,
    max: 100,
    step: 1,
  },
  "site-title-columns": {
    min: 1,
    max: 10,
    step: 1,
  },
  "total-star-rating": {
    min: 0,
    max: 100,
    step: 1,
  },
  "star-rating": {
    min: 0,
    max: 100,
    step: 1,
  },
  "css-filters-brightness": {
    min: 0,
    max: 200,
    step: 1,
  },
  "css-filters-blur": {
    min: 0,
    max: 10,
    step: 0.1,
  },
  "css-filters-contrast": {
    min: 0,
    max: 200,
    step: 1,
  },
  "css-filters-saturation": {
    min: 0,
    max: 200,
    step: 1,
  },
  "css-filters-hue": {
    min: 0,
    max: 360,
    step: 1,
  },
};
